import styled from "styled-components";

export const ErrorMessageBox = styled.div<{visible: boolean}>`
    color: ${props => props.theme.colors.danger};
    visibility: ${props => props.visible ? 'visible' : 'hidden'};
    min-height: 17px;
    padding: 0 0 0 4px;
`